import cx from 'classnames'
import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { InterestsSelection } from 'features/Interests'

import Button from 'components/Button'

export const InterestsSelectionModal = ({
  returnPath,
}: {
  returnPath?: string
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const ref = useRef<HTMLButtonElement>(null)
  const [isSaving, setIsSaving] = useState(false)

  const onSave = () => {
    if (isSaving) return

    setIsSaving(true)
    ref.current?.click()
  }

  const onSaveCallback = (isSuccess: boolean) => {
    setIsSaving(false)
    if (isSuccess) onClose()
  }

  const onClose = () => {
    navigate(returnPath || location.pathname)
  }

  return (
    <div className="Modal__wrapper Modal__wrapper--auto-h InterestsSelectionModal">
      <div className="Modal__header">
        <a
          className={cx('Modal__header__close', {
            'Modal__header__close--back': returnPath,
          })}
          onClick={onClose}
        />

        <h2 className="Modal__header__h2">
          {t('user_setting.interests_selection.modal.title')}
        </h2>

        <Button
          className="Modal__header__right InterestsSelectionModal__save-button"
          buttonStyle="secondary"
          onClick={onSave}
          disabled={isSaving}
        >
          {t('common.save')}
        </Button>
      </div>

      <div className="Modal__body">
        <InterestsSelection
          isModal
          saveButtonRef={ref}
          saveCallback={onSaveCallback}
        />
      </div>
    </div>
  )
}
